"use strict";

exports.__esModule = true;
exports.checkValidId = void 0;

var checkValidId = function checkValidId(id) {
  if (!id || typeof id === 'number' && id <= 0) {
    throw new Error("id: " + id + " is invalid.");
  }
};

exports.checkValidId = checkValidId;